import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {User} from '../../types'

const queryKey = 'user-search'

type UseUserSearchParams = {
  plantId: string
  namePattern: string | undefined
}

type UseUserSearchOptions = Omit<UseQueryOptions<User[], AxiosError>, 'queryKey'>

export const useUserSearch = (
  {plantId, namePattern}: UseUserSearchParams,
  options?: UseUserSearchOptions
) => {
  return useQuery<User[], AxiosError>({
    queryKey: [queryKey, namePattern, plantId],
    queryFn: async () => {
      const path = `/shifthandover/${plantId}/search/taskassignee?namePattern=${namePattern}`

      if (!namePattern) {
        return Promise.resolve([])
      }
      const response = await ApiClient.axiosInstance.post<User[]>(path)
      return response.data
    },
    gcTime: 60000,
    refetchOnWindowFocus: false,
    ...options
  })
}
